module.exports = "div.credito-maximo-wrapper {\n  padding-left: 2.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/hipotecario/simulacion/creditos-hipotecario-simulacion.component.scss
// module id = ./src/app/creditos/hipotecario/simulacion/creditos-hipotecario-simulacion.component.scss
// module chunks = main